import { VersionErrorLOFactory } from './../../../externalLogging/factories/VersionErrorLOFactory';
import { ExternalLog } from './../../../externalLogging/ExternalLog';
import { CommandController } from './../../../commanding/CommandController';
/**
 * Created with IntelliJ IDEA.
 * User: aprzybyszewski
 * Date: 29.04.13
 * Time: 11:36
 * To change this template use File | Settings | File Templates.
 */


import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import { BasicCommand } from "./BasicCommand";
import { BasicErrorConstants } from "./constants/BasicErrorConstants";
import { BasicModel } from "../../model/BasicModel";
import { BasicController } from "../BasicController";
import { ServerErrorVO } from "../clientCommands/vo/ServerErrorVO";

export class VCKCommand extends BasicCommand {
    protected static VERSION_TOO_LOW: number = 1;
    protected static VERSION_TOO_HIGH: number = 2;

    protected get cmdId(): string {
        return BasicSmartfoxConstants.C2S_VERSION_CHECK;
    }

    public executeCommand(error: number, params: any[]): boolean {
        this.env.buildNumberServer = params[2];
        this.env.versionInformation.buildNumberServer = params[2];

        if (error == BasicErrorConstants.ALL_OK) {
            this.handleAllOk();
        }
        else if (error == VCKCommand.VERSION_TOO_LOW) {
            this.handleVersionToLow();
            this.logError(error);
        }
        else if (error == VCKCommand.VERSION_TOO_HIGH) {
            this.handleVersionToHigh();
            this.logError(error);
        }
        else {
            CommandController.instance.executeCommand(BasicController.COMMAND_HANDLE_SERVER_ERROR, new ServerErrorVO(error, params, this.cmdId));
            this.logError(error);
        }

        return false;

    }

    protected handleAllOk(): void {
        if (this.env.isSSO) {
            // Check if social player has an account (social player exists)
            BasicModel.smartfoxClient.sendMessage(BasicSmartfoxConstants.C2S_SOCIAL_PLAYER_EXISTS, [this.env.pln, this.env.sig]);
            return;
        }

        CommandController.instance.executeCommand(BasicController.CHOOSE_LOGIN_METHOD);
    }

    public logError(error: number): void {
        ExternalLog.logger.log(new VersionErrorLOFactory(VersionErrorLOFactory.OLD_CLIENT_VERSION_ERROR, this.env.buildNumberServer));
    }

    protected handleVersionToLow(): void {
        // override
    }

    protected handleVersionToHigh(): void {
        // override
    }
}

